import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

function EditSubscriptionForm({ subscriptionId, onSuccess, onCancel }) {
  const [form, setForm] = useState({ name: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchSubscription() {
      setLoading(true);
      try {
        const res = await fetch(`${API_URL}/api/subscriptions/${subscriptionId}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        if (!res.ok) throw new Error('Failed to fetch subscription');
        const data = await res.json();
        setForm({ name: data.name, email: data.email });
      } catch (err) {
        setError(err.message);
      }
      setLoading(false);
    }
    if (subscriptionId) {
      fetchSubscription();
    }
  }, [subscriptionId]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/subscriptions/${subscriptionId}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(form),
      });
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(JSON.stringify(errorData) || 'Failed to update subscription');
      }
      onSuccess();
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Edit Subscription</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <input
        name="name"
        type="text"
        placeholder="Name"
        value={form.name}
        onChange={handleChange}
        required
        className="input"
      />
      <input
        name="email"
        type="email"
        placeholder="Email"
        value={form.email}
        onChange={handleChange}
        required
        className="input"
      />
      <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
        <button type="submit" className="btn-primary-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save Changes'}
        </button>
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}

export default EditSubscriptionForm;
